import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LinkIcon from "@mui/icons-material/Link";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useEffect } from "react";

function ShareModal() {

  useEffect(()=>{
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: '630905682261052',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v13.0'
      });
    };
  },[])
  
    /* Share */
  
    const facebook = () => {
      window.FB.ui({
        display: 'popup',
        method: 'share',
        href: window.location.href,
      }, function(response){console.log(response)});
    }


  return (
    <div className="container-modal-share-main">
      <h3>Comparte nuestra historia en:</h3>
      <div className="line-grey">.</div>
      <h4>Comparte via!</h4>
      <div className="container-red">
      <button onClick={facebook}>
              <FacebookIcon sx={{ color: "white" }} />
              </button>
        <InstagramIcon sx={{ color: "white" }} />
        <LinkedInIcon sx={{ color: "white" }} />
        <WhatsAppIcon sx={{ color: "white" }}/>
      </div>
      <span>O copia nuestro Link!</span>
      <div className="container-link-copy">
        <div className="link">
          <LinkIcon />
          <span>Link.com/ejemplo/linkPrueba.com</span>
        </div>
        <button>Copiar!</button>
      </div>
    </div>
  );
}

export default ShareModal;
